import { render, staticRenderFns } from "./FormFillUpFee.vue?vue&type=template&id=81a70cd8&scoped=true&"
import script from "./FormFillUpFee.vue?vue&type=script&lang=js&"
export * from "./FormFillUpFee.vue?vue&type=script&lang=js&"
import style0 from "./FormFillUpFee.vue?vue&type=style&index=0&id=81a70cd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a70cd8",
  null
  
)

export default component.exports